import { render, staticRenderFns } from "./CamposFormulario.vue?vue&type=template&id=3a7061da&"
import script from "./CamposFormulario.vue?vue&type=script&lang=js&"
export * from "./CamposFormulario.vue?vue&type=script&lang=js&"
import style0 from "./CamposFormulario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports